module.exports = __webpack_public_path__ + "img/0Q3B8222_BlackMatted_MockedUp.48db28ae.jpg";